










import Vue from 'vue';

export default Vue.extend({
  name: 'HMPhotoIcon',
  props: {
    instructor: {
      type: Object as () => InstructorResponse,
      required: true,
    },
    size: {
      type: String,
      default: '25px',
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    imgUrl() {
      return (
        this.instructor.image?.thumbnail ||
        this.instructor.image?.embedded_image_url ||
        this.instructor.image ||
        this.instructor.profile_photo ||
        this.instructor.community_profile_photo ||
        '/assets/images/default-instructor-photo.png'
      );
    },
  },
});
